export { default } from "@/app/(app)/home/profile/index";
